import type { ReactNode } from 'react';

interface SegmentedProps<T extends string> {
  name: string;
  value: T;
  options: { value: T; label: ReactNode }[];
  onChange: (value: T) => void;
  wrap?: boolean;
  label?: string;
}

/** Radio group styled as a segmented control (keyboard accessible). */
export function Segmented<T extends string>({ name, value, options, onChange, wrap, label }: SegmentedProps<T>) {
  return (
    <div className={`segmented${wrap ? ' wrap' : ''}`} role="radiogroup" aria-label={label}>
      {options.map((o) => (
        <label key={o.value} className="segmented-option">
          <input type="radio" name={name} value={o.value} checked={value === o.value} onChange={() => onChange(o.value)} />
          <span>{o.label}</span>
        </label>
      ))}
    </div>
  );
}
